import { WorkflowFormSection } from './workflow-form-section.interface';

export interface WorkflowForm {
    name: string;
    area: string;
    sectionsToCreate: WorkflowFormSection[];
}
